// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentSchemeDetailsSection_container__1tA8f","loading":"PaymentSchemeDetailsSection_loading__2JS4v"};